import ContentGuide from 'global/guides/ContentGuide'
import { useAuth } from 'hooks'
import { Outlet, useOutletContext } from 'react-router-dom'
import { RegraCalculoPresenter, regrasCalculo } from 'service/api'
import { columns } from 'templates/Cadastro/RegrasCalculo/constants'

export default function RegrasCalculo() {
    const {
        decoded: { cliente: clienteId },
    } = useAuth()
    const { data, isLoading } = regrasCalculo.useFetch({
        queryParams: { clienteId },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Cadastros', 'Regras de cálculo']}
                />
                <ContentGuide.DataGrid
                    columns={columns}
                    rows={data}
                    loading={isLoading}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-regras-calculo',
                        },
                        showQuickFilter: true,
                        hideFilterButton: true,
                    }}
                    onAdd
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useRegrasCalculoContext() {
    return useOutletContext<{
        data: RegraCalculoPresenter[]
    }>()
}
